var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-spinner"},[_vm._m(0),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMessage),expression:"showMessage"}],staticClass:"message text-center mt-4"},[_vm._v("Cargando datos, espera un momento por favor ...")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }